import axios from 'axios';
import {BACKEND_URL} from '../constants/ServiceUrl'

export default {
    get(data){
        return axios.post(BACKEND_URL+'Form/FormGroupPreset/get.php', data);
    },
    add(data){
        return axios.post(BACKEND_URL+'Form/FormGroupPreset/add.php', data);
    },
    rename(data) {
        return axios.put(BACKEND_URL+'Form/FormGroupPreset/rename.php', data);
    },
    delete(data){
        return axios.put(BACKEND_URL+'Form/FormGroupPreset/delete.php', data);
    },
    getGroupLabels(data) {
        return axios.post(BACKEND_URL+'Form/FormGroupPreset/getPresetLabels.php', data);
    },
    addLabels(data){
        return axios.post(BACKEND_URL+'Form/FormGroupPreset/addPresetLabels.php', data);
    },
    renameLabel(data){
        return axios.put(BACKEND_URL+'Form/FormGroupPreset/renameLabel.php', data);
    },
    deleteLabel(data){
        return axios.put(BACKEND_URL+'Form/FormGroupPreset/deleteLabel.php', data);
    },
    updateFormGroup(data) {
        return axios.put(BACKEND_URL+'Form/FormGroupPreset/updateFormGrouping.php', data);
    }
}


// WEBPACK FOOTER //
// ./src/api/FormGroupPresetApi.js